export default "__VITE_ASSET__C9tonF_T__"